import { BaseRepository, UpdatableBaseRepository } from "../repository/base.repository";
import { BaseEntity } from "@/backend/shared/repository/BaseEntity";

//

export abstract class BaseService<Entity extends BaseEntity> {
  constructor(public repository: BaseRepository<Entity>) {}
}

//

export abstract class BaseUpdatableService<
  Entity extends BaseEntity,
  Creating extends Partial<Entity>,
> {
  constructor(public repository: UpdatableBaseRepository<Entity, Creating>) {}
}
